import React, { useEffect, useState } from "react";
import { Banner } from '../../components';
import { ClientsRow } from '../../components';
import { HeroIndustries } from '../../components';
import { IndustriesSpriteJpg } from '../../components';
import { VideoFullSection } from '../../components';
import { VideoScroll } from '../../components';
import { IndustriesCarouselMenu } from '../../components';
import { VideoScrollAlone } from '../../components';
import { Loader } from '../../components';

import { imagesArray } from '../../sprites/RealEstate';
import { BaseUrl } from "../../config";

const LandingRealEstateContainer = (props) => {

  const boxesArray = [
    {
      title: "Highest Quality",
      text: "Our ultra-realistic real-time rendered 3D Digital Twins are compliant to the most stringent of industry standards and created through our patented pipeline methodologies."
    },
    {
      title: "Active Experience",
      text: "We bring the digital experience to the highest level, comparable to the real-world experience where users can fully engage with the environment, products, and assets."
    },
    {
      title: "Growth Acceleration",
      text: "Transform and boost your business and company towards a “digital culture” and enable yourself to experience the enhanced opportunities of the full digital ecosystem."
    }
  ];
  const imgHeroIndustries = require('../../assets/hero-real-estate.png');
  
  const sprites = imagesArray;
  const arrayLoad = [
    imgHeroIndustries,
    ...sprites
  ]
  
  const [listClients, setListClients] = useState([]);

  useEffect(() => {
    document.title = "Invrsion for Real Estate"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=real-estate`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setListClients(res.data.company.clients);
    })
    
    
  }, []);
    
  return (
    <React.Fragment>
      <HeroIndustries
        title="A new era for Real Estate starts here." 
        bgColor="linear-gradient(105.88deg, rgba(215, 48, 50, 1), rgba(244, 160, 127, 1))"
        img={imgHeroIndustries}
       />
       <IndustriesSpriteJpg 
        idScroll="3-real-estate" 
        title="How our Full Reality solutions fulfill your needs" 
        black="#420704"
        boxesArray={boxesArray}
        imagesArray={sprites}
      />
      <VideoFullSection 
        bgColor="#F4A07F"
        title="Virtual Showroom"
        black="#420704"
        route="/products/virtual-showroom"
        noMarginBottom={true}
        zIndex={3}
        text="Our solution to fully immerse potential buyers and investors in the spaces and projects you want to sell and rent. Giving them the keys to every listing you have on the market."
      >
        <VideoScroll 
          idScroll="video-real-01" 
          video={require('../../assets/video/video-real-estate-1.mp4')} 
        />
      </VideoFullSection>
      
      <IndustriesCarouselMenu
        colorCTA="#D73032"
        black="#420704"
        slider={[3,2,0]}
      >
        <h3 className="big--title" style={{color: '#420704'}}>
          We want to emphasize the “real” in real estate
        </h3>
      </IndustriesCarouselMenu>
      <VideoScrollAlone
        idScroll="video-real-03"
        video={require('../../assets/video/video-real-estate-3.mp4')} 
      />
      {
        listClients.length > 0 &&
        <ClientsRow 
          black="#420704"
          title="Real estate brands that are already on board and trust in Invrsion's solutions"
          arrayClients={listClients}/>
      }
      <Banner bgColor="#FCF2EB" text="Intrigued? Let’s have a chat." route="/reach-out" copyRoute="Reach out" black="#420704"/>
      <Loader arrayLoad={arrayLoad} />

    </React.Fragment>
  );
};

export default LandingRealEstateContainer;
